import {ReactNode} from "react";
import {Metadata} from "../../utils/hooks/useFixtureFootage";

export const SET_EDITOR_ANGLES = "SET_EDITOR_ANGLES";
export const SET_EDITOR_SELECTED_ANGLES = "SET_EDITOR_SELECTED_ANGLES";
export const SET_EDITOR_DROPDOWN_ANGLES = "SET_EDITOR_DROPDOWN_ANGLES";
export const SET_EDITOR_INITIALISED_ANGLES = "SET_EDITOR_INITIALISED_ANGLES";
export const SET_EDITOR_ANGLES_AUDIO = "SET_EDITOR_ANGLES_AUDIO";
export const SET_EDITOR_AUDIO_PLAYER_READY = "SET_EDITOR_AUDIO_PLAYER_READY";

export interface FixtureFiles {
    id: string;
    object_id: string;
    name: string;
    fixture_id: string;
    metadata: Metadata;
    collection_id: string | undefined;
    uploaded_to_hudl?: boolean;
    file_type: "VIDEO" | "PDF";
    status: "UPLOADING" | "TRANSCODING" | "MARKUP" | "AVAILABLE" | "ARCHIVED" | "ERROR";
    sub_type:
        | "VIDEO_BROADCAST"
        | "VIDEO_TACTICAL"
        | "VIDEO_HIGH_BEHIND_ONE"
        | "VIDEO_HIGH_BEHIND_TWO"
        | "VIDEO_EIGHTEEN_YARD_ONE"
        | "VIDEO_EIGHTEEN_YARD_TWO"
        | "VIDEO_HIGHLIGHTS"
        | "VIDEO_PANORAMIC"
        | "VIDEO_CLIP"
        | "VIDEO_BROADCAST_COMMS"
        | "AUDIO_COMMS";
}

export interface Angle {
    angleId: string;
    angleName: string;
    elementId: string;
    elementKey: string;
}

export type AnglesAudioUpdater = (prev: AngleAudio[]) => AngleAudio[];

export interface AngleAudio {
    angleId : string;
    audioTrackId: number;
    commonAngleId: string;
}

export interface SetEditorAnglesAction {
    type: typeof SET_EDITOR_ANGLES;
    angles: FixtureFiles[];
}

export interface SetEditorSelectedAnglesAction {
    type: typeof SET_EDITOR_SELECTED_ANGLES;
    selectedAngles: Angle[];
}

export interface SetEditorDropdownAnglesAction {
    type: typeof SET_EDITOR_DROPDOWN_ANGLES;
    dropdownAngles: FixtureFiles[];
}

export interface SetInitialStateAction {
    type: typeof SET_EDITOR_INITIALISED_ANGLES;
    anglesInitialised: boolean;
}

export interface SetEditorAnglesAudioAction {
    type: typeof SET_EDITOR_ANGLES_AUDIO;
    anglesAudio: AngleAudio[] | AnglesAudioUpdater;
}

export interface SetEditorAudioPlayerReadyAction {
    type: typeof SET_EDITOR_AUDIO_PLAYER_READY;
    audioPlayerReady: boolean;
}

export type Action = SetEditorAnglesAction
    | SetEditorSelectedAnglesAction
    | SetEditorDropdownAnglesAction
    | SetInitialStateAction
    | SetEditorAnglesAudioAction
    | SetEditorAudioPlayerReadyAction;

export type State = {
    angles: FixtureFiles[];
    selectedAngles: Angle[];
    dropdownAngles: FixtureFiles[];
    anglesInitialised: boolean;
    anglesAudio: AngleAudio[];
    audioPlayerReady: boolean;
}

export type Dispatch = (action: Action) => void;

export type EditorAnglesProps = { children: ReactNode };
